export const SET_INVEST_AMOUNT = "SET_INVEST_AMOUNT";
export const SET_LAST_AMOUNT_INVEST = "SET_LAST_AMOUNT_INVEST";
